import { render, staticRenderFns } from "./PayrollHistory.vue?vue&type=template&id=b33dfca8&scoped=true&"
import script from "./PayrollHistory.vue?vue&type=script&lang=js&"
export * from "./PayrollHistory.vue?vue&type=script&lang=js&"
import style0 from "./PayrollHistory.vue?vue&type=style&index=0&id=b33dfca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33dfca8",
  null
  
)

export default component.exports